import { Check } from 'lucide-react';
import { SecondaryButton } from '../components/Button';
import { copy } from '../copy';
import { stopCounts } from '../state/route';
import { useAppStore } from '../state/store';

/** I3 — Einde van de rit. Geen score, geen percentage, geen vergelijking. */
export function DoneScreen() {
  const route = useAppStore((s) => s.route);
  const navigate = useAppStore((s) => s.navigate);

  if (!route) return null;
  const counts = stopCounts(route);

  /*
   * Drie gevallen, elk met een bestaande copy-regel — er wordt niets bij verzonnen:
   * - alles bezorgd            -> "Alle {n} stops bezorgd. ..."
   * - alleen herbezorgingen    -> "{n} bezorgd, {m} gaat morgen opnieuw mee. ..."
   * - open stops (D138/B4), of mislukt zonder herbezorging -> de nuchtere telling uit de
   *   afrondsheet: "{n} bezorgd, {m} niet gelukt. Alles is verstuurd." Open stops tellen
   *   daarin niet als niet gelukt; zie AFWIJKINGEN.md B-16.
   */
  const summary =
    counts.open === 0 && counts.failed === 0
      ? copy.ret.doneAllDelivered(counts.delivered)
      : counts.open === 0 && counts.failed > 0 && counts.redelivered === counts.failed
        ? copy.ret.doneMixed(counts.delivered, counts.redelivered)
        : copy.ret.sheetMixed(counts.delivered, counts.failed);

  return (
    <div className="screen" data-screen="done">
      <div className="screen__body screen__body--center pad-x">
        <div className="stack" style={{ gap: 16 }}>
          <span
            aria-hidden
            style={{
              width: 88,
              height: 88,
              borderRadius: 'var(--radius-pill)',
              background: 'var(--color-mint)',
              color: 'var(--on-accent)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Check size={40} strokeWidth={2} />
          </span>
          <h1 className="t-serif" style={{ fontSize: 34 }}>
            {copy.ret.doneTitle}
          </h1>
          <p className="o-75" style={{ fontSize: 18, lineHeight: 1.55, margin: 0 }}>
            {summary}
          </p>
        </div>
      </div>
      <div className="screen__foot">
        <SecondaryButton onClick={() => navigate('day')}>{copy.ret.doneBack}</SecondaryButton>
      </div>
    </div>
  );
}
